import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AppServices } from './../../app.services';
import { NotifyService } from './../../addon/notify.service';

declare var $:any;

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
	session; tasks;
	constructor(private router: Router, private activatedroute: ActivatedRoute, private appServices: AppServices, private notifyService: NotifyService) { }

	ngOnInit() {
		$('[data-toggle="offcanvas"]').on('click', function () {
			$('.offcanvas-collapse').toggleClass('open')
		})
		this.session = this.appServices.session[0];
		if(this.session) {
			this.appServices.api('Taskxmembers/find', {
				'filter': `{"where":{"deleted":false, "codemember":"${this.session.member.code}"}}`
			}, this).then(function(obj){
				let res = obj.response.json().res;
				obj.component.tasks = res.filter(function(val){
					return Date.parse(val.task.duedate) - Date.now() < 0;
				})
			}).catch(function(err){
				err.component.notifyService.show(err.err.json().error.message, 'danger');
			})
		} else {
			this.router.navigate(['main/home'])
		}
	}

}



// WEBPACK FOOTER //
// D:/wamp/www/sportal/pmi/web/src/app/layout/header/header.component.ts